export { Ccategoryicon } from './Ccategoryicon';
export type { CcategoryiconProps } from './Ccategoryicon';

